import React, { Component } from 'react';
import './SortPage.css';
import '@shopify/polaris/dist/styles.css';
import { AppProvider } from '@shopify/polaris';
import Sort from '../components/Sort';
import { getFetch } from '../helpers/request';

interface SortPageProps {
  id: string,
  match: any
}

interface SortPageState {
  shopOrigin: string
}

class SortPage extends Component <SortPageProps, SortPageState> {

  constructor(props: SortPageProps) {
    super(props);
    this.state = {
      shopOrigin: ''
    };
  }

  componentDidMount() {
    //check if log in
    getFetch('/app/api/shopify/user', {})
    .then((res:any) => res.json()
    ).then(data => {
      this.setState({ shopOrigin: data.shop_origin })
    }).catch(err => {

    });
  }

  render() {
    return (
      this.state.shopOrigin !== '' &&
      <AppProvider i18n={{}}>
        <Sort shopOrigin={this.state.shopOrigin} type="existing" id={this.props.match.params.sortId}></Sort>
      </AppProvider>
    );
  }
}

export default SortPage;
